/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderPermission } from '@gh/builder-shared-data';
import { PlainImmutablePageState, UserContext } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';
import {
  AccountingAccount,
  accountingAccountArr,
  getAccountingAccountId,
  SystemVarsAccountingJobsModel,
} from '../../../resources';

@Injectable()
export class SystemVarsAccountingJobsFormState extends PlainImmutablePageState<SystemVarsAccountingJobsModel> {
  jobAccounts$ = this.select(({ jobAccounts }) => jobAccounts);

  constructor(private userContext: UserContext) {
    super({ jobAccounts: [] }, FormMode.EditMode);
  }

  build(details: SystemVarsAccountingJobsModel): void {
    this.setValue(details);
    this.setMode(this.userContext.hasPermission(BuilderPermission.Setup.SystemVariables.Accounting.EDIT)
      ? FormMode.EditMode
      : FormMode.ViewMode,
    );
    this.resetDirty();
  }

  deleteRecord(record: AccountingAccount): void {
    this.startChangeDetection();
    this.setField('jobAccounts', accountingAccountArr.remove(this.value.jobAccounts, getAccountingAccountId(record)));
    this.setDirtyIfChanged();
  }

  addRecords(records: AccountingAccount[]): void {
    this.startChangeDetection();
    this.setField('jobAccounts', accountingAccountArr.append(this.value.jobAccounts, ...records));
    this.setDirtyIfChanged();
  }
}
